import { CaseSidebarItemId, CaseSidebarSection } from '../types';

export const SECTION_REQUIRED_FEATURE_FLAGS: Partial<Record<CaseSidebarSection, string[]>> = {};

export const ITEM_REQUIRED_FEATURE_FLAGS: Partial<Record<CaseSidebarItemId, string[]>> = {};
